import { useNavigate } from "react-router-dom"
import useTargetStorage from "@/hooks/useTargetStorage"
import LocationList from "features/storages/locations/locationList"
import Callout from "components/callout/callout"
import { useTranslation } from "react-i18next"
import Section from "components/layout/section"
import RightSidebar from "components/sidebar/right/RightSidebar"
import SectionHeader from "components/layout/sectionHeader"
import SectionHeaderTitle from "components/layout/sectionHeaderTitle"
import SectionHeaderActions from "components/layout/sectionHeaderActions"
import Button from "components/inputs/button"
import { ReactComponent as AddIcon } from "assets/icons/add.svg"
import PageTitle from "features/navigation/pageTitle"
import useAccess from "@/hooks/useAccess"
import useStorages from "@/hooks/useStorages"
import { paramGuardStorage } from "@/utils/paramGuard"
import { AccessRole, DeviceSize } from "@/types"
import IconButton from "@/components/buttons/iconButton"
import useWindowDimensions from "@/hooks/useWindowDimensions"
import { MainSheetHeaderActions } from "@/components/layout/layoutChrome"

const Locations = () => {

    const { t } = useTranslation()
    const navigate = useNavigate()
    const { displayIfSize } = useWindowDimensions()

    const { targetStorageDocId: storageId } = useTargetStorage()
    const { storage, storageStatus } = useStorages({ storageId })
    
    const {
        limitToRoles
    } = useAccess({ storageId: storageId || '' })

    if (!paramGuardStorage({storageId, storage, storageStatus, navigate})) {
        return <></>
    }
    const safeStorageId = storageId!;

    return (
        <>
            <PageTitle title={t('titleLocations')} />
            <MainSheetHeaderActions>
                { limitToRoles([AccessRole.OWNER, AccessRole.EDITOR]) &&
                    <>
                        {!displayIfSize([DeviceSize.SM]) && <Button wideOnMobile design="primary" to={`/storages/${safeStorageId}/locations/create`}><AddIcon /><span>{t(`buttonNewLocation`)}</span></Button>}
                        {displayIfSize([DeviceSize.SM]) && <IconButton colorScheme="blue" icon={<AddIcon />} to={`/storages/${safeStorageId}/locations/create`} />}
                    </>
                }
            </MainSheetHeaderActions>
            <Callout type="info" id={`location-page-info`}>{t('locationsInfo')}</Callout>
            <Section padX={false}>
                <LocationList storageId={safeStorageId} />
            </Section>
            <RightSidebar storageId={safeStorageId} />
        </>
    )
}

export default Locations
